<template>
  <div class="weapon_wrap">
    <div
      v-if="items.length && !pending"
      class="pb60"
    >
      <UiItemsGrid>
        <LazyPagesSearchComponentsSearchItemCard
          v-for="item in items"
          :key="item?.market_hash_name"
          :item="item"
          :link="getItemLinkWithExterior({
            name: item.market_hash_name,
            slug: item.link,
          })"
        />
      </UiItemsGrid>
      <PaginateV2
        key="paginate"
        :model-value="pagination.page"
        :pages-length="pagination.pagesLength"
        @on-page-change="emit('onPageChange', $event)"
      />
    </div>
    <LazyUiNoResult
      v-if="!pending && !items?.length"
      class="ma no_result"
    />
    <div
      v-if="pending"
      class="load_period loading-container f fc"
    >
      <i class="i-loading" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { AdvancedSearchBody } from '~/graphql/generated/schema-types';

defineProps<{
  pending: boolean
  items: AdvancedSearchBody[]
  pagination: {
    page: number
    pagesLength: number
  }
}>();
const emit = defineEmits(['onPageChange']);
</script>

<style lang="scss" scoped>
.main_weapon_wrap {
  display: flex;
  justify-content: center;
  @media screen and (max-width: 1250px) {
    padding-top: 0;
  }
}

.loading-container {
  height: 50vh;
}

.no_result {
  height: 60vh;
  width: 100%;
}

.weapon {
  section {
    margin: 3.2rem 0;

    h1 {
      font-size: 2.4rem;
      margin-bottom: 2.4rem;
    }
  }

  &_wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 7rem;
    padding-right: 16px;
    @media screen and (max-width: 1250px) {
      margin-top: 0;
    }
    @media screen and (max-width: 1115px) {
      padding-right: 0;
    }
  }

  &-first {
    width: 100%;

    .weapon-item {
      display: flex;
      align-items: center;
      justify-content: center;

      .item-image {
        border-radius: 8px;
        width: 38.4rem;
        height: 38.4rem;
        display: flex;
        transition: 1s;
        @media screen and (max-width: 525px) {
          width: 100%;
          min-width: 100%;
        }
      }

      .item-info {
        margin-left: 4.8rem;

        .item-name {
          display: flex;
          align-items: center;
          color: var(--surfaces-on-surface);
          font-weight: 600;
          font-size: 2.8rem;
          line-height: 3.8rem;
          transition: 1s;
        }

        .item-description {
          margin-top: 1.6rem;
          font-weight: 400;
          font-size: 1.6rem;
          line-height: 3.2rem;
          display: flex;
          align-items: center;
          color: var(--surfaces-on-surface);
          opacity: 0.8;
          max-width: 68rem;
          transition: 1s;
        }
      }
    }
  }
}

@media screen and (max-width: 1075px) {
  .weapon {
    .weapon_wrap {
      gap: 4rem;
    }

    &-first {
      .weapon-item {
        .item-info {
          margin-left: 3rem;

          .item-name {
            font-size: 2.4rem;
            line-height: 3.4rem;
          }

          .item-description {
            font-size: 1.4rem;
            line-height: 3rem;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .weapon {
    .weapon_wrap {
      gap: 4rem;
    }

    &-first {
      .weapon-item {
        flex-direction: column;

        .item-info {
          margin-left: 0;
          margin-top: 1.6rem;

          .item-name {
            font-size: 2.2rem;
            line-height: 3.2rem;
          }

          .item-description {
            margin-top: 1.2rem;
            line-height: 2.8rem;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 525px) {
  .weapon {
    .weapon_wrap {
      gap: 1.6rem;
    }

    &-first {
      .weapon-item {
        .item-image {
          margin-left: 1.5rem;
          margin-right: 1.5rem;
          background: rgba(33, 40, 53, 0.2);
          border-radius: 1.2rem;
        }

        .item-info {
          .item-name {
            font-size: 2rem;
            line-height: 2.7rem;
          }

          .item-description {
            margin-top: 0.8rem;
            line-height: 2.6rem;
          }
        }
      }
    }
  }
}
</style>
